<template>
  <avtalat-input
    id="email"
    v-model:value="email"
    :required="required"
    :label="label"
  />
  <FormErrorMessage name="email" />
</template>

<script setup lang="ts">
import FormErrorMessage from "../ui/FormErrorMessage.vue";

defineProps<{
  label: string;
  required: boolean;
}>();

const email = defineModel<string>();
</script>
